import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { StoreProvider } from './context/StoreContext';
import { AppLayout } from './layout/AppLayout';
import { LoginPage } from './pages/LoginPage';
import { ProductManagement } from './pages/ProductManagement';
import { StockManagement } from './pages/StockManagement';
import { SalesPOS } from './pages/SalesPOS';
import { ExpenseManagement } from './pages/ExpenseManagement';
import { Reports } from './pages/Reports';
import { UserManagement } from './pages/UserManagement';
import { GuestRoute, ProtectedRoute } from './routes/ProtectedRoute';
import './App.css';

function CatchAll() {
  const { currentUser } = useAuth();
  return <Navigate to={currentUser ? '/sale' : '/'} replace />;
}

function AppRoutes() {
  return (
    <Routes>
      {/* Login is at root */}
      <Route
        path="/"
        element={
          <GuestRoute>
            <LoginPage />
          </GuestRoute>
        }
      />

      {/* Backwards-compat: old login url */}
      <Route path="/login" element={<Navigate to="/" replace />} />

      <Route element={<ProtectedRoute />}>
        <Route element={<AppLayout />}>
          <Route path="/sale" element={<SalesPOS />} />
          <Route path="/pos" element={<Navigate to="/sale" replace />} />
          <Route path="/products" element={<ProductManagement />} />
          <Route path="/stock" element={<StockManagement />} />
          <Route path="/expenses" element={<ExpenseManagement />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/users" element={<UserManagement />} />
        </Route>
      </Route>

      <Route path="*" element={<CatchAll />} />
    </Routes>
  );
}

function App() {
  return (
    <StoreProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </AuthProvider>
    </StoreProvider>
  );
}

export default App;

